import StencilHTMLElement from "./stencil-element";

class ProductOrderFreeSample extends StencilHTMLElement {
  name = "ProductOrderFreeSamples";

  constructor() {
    super();
    this.orderFreeSampleProduct = this.orderFreeSampleProduct.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.orderFreeSampleProduct.bind(this));
  }

  async orderFreeSampleProduct(e) {
    const button = e.currentTarget;

    button.classList.add('loading');
    button.querySelector(".spinner-overlay").classList.remove('d-none');

    const variantId = button.dataset.freeSampleVariantId;

    try {
      await window.Stencil.Extensions.Cart.add([{ id: variantId }]);
      setTimeout(() => this.onFreeSampleAddedToCart(button), 1500);
    } catch (error) {
      console.error(this.logPrefix,"Error adding free sample to cart:", error);
      this.onFreeSampleError(button);
    }
  }

  onFreeSampleAddedToCart(button) {
    button.classList.remove('loading');
    button.querySelector(".spinner-overlay").classList.add('d-none');
  }

  onFreeSampleError(button) {
    button.classList.remove('loading');
    button.querySelector(".spinner-overlay").classList.add('d-none');
  }
}

export default ProductOrderFreeSample;
